__turbopack_context__.v({
  "brand-text-container": "Footer-module-scss-module__a9fGWq__brand-text-container",
  "contact": "Footer-module-scss-module__a9fGWq__contact",
  "contact-headline": "Footer-module-scss-module__a9fGWq__contact-headline",
  "contact-link": "Footer-module-scss-module__a9fGWq__contact-link",
  "contact-opening-hours": "Footer-module-scss-module__a9fGWq__contact-opening-hours",
  "footer": "Footer-module-scss-module__a9fGWq__footer",
  "footer-section": "Footer-module-scss-module__a9fGWq__footer-section",
  "footer-top": "Footer-module-scss-module__a9fGWq__footer-top",
  "home-link": "Footer-module-scss-module__a9fGWq__home-link",
  "mapper-a": "Footer-module-scss-module__a9fGWq__mapper-a",
  "mapper-p": "Footer-module-scss-module__a9fGWq__mapper-p",
  "menu": "Footer-module-scss-module__a9fGWq__menu",
  "placeholder": "Footer-module-scss-module__a9fGWq__placeholder",
  "primary-nav": "Footer-module-scss-module__a9fGWq__primary-nav",
  "primary-nav-headline": "Footer-module-scss-module__a9fGWq__primary-nav-headline",
  "primary-nav-item": "Footer-module-scss-module__a9fGWq__primary-nav-item",
  "primary-nav-menu": "Footer-module-scss-module__a9fGWq__primary-nav-menu",
  "teaser": "Footer-module-scss-module__a9fGWq__teaser",
});
